// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"5044":"c213cb58","7824":"9123c13e"}[chunkId] || chunkId) + "." + {"2406":"74dabad50d740823","2640":"4ee36880ace6a926","3225":"01b835c3ce8e1eac","3740":"05d60c45e203aab5","5044":"f94601663e3fb27c","7824":"d9df338c00dcba99","8978":"5a920b0cf5f5c38e","9483":"5b97dd925f8b86bc"}[chunkId] + ".js";
};